import React from "react";
import {
  Box,
  Button,
  Divider,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
  useTheme,
  IconButton,
  Avatar,
  Tooltip,
} from "@mui/material";
import { alpha } from "@mui/material/styles";
import {
  HomeOutlined,
  InfoOutlined,
  // InsertChartOutlined,
  LockOutlined,
  // TableChart,
  SupervisorAccountOutlined,
  // MonitorHeart,
  Brightness4,
  Brightness7,
  ChevronLeft,
  Groups,
  LogoutOutlined,
  EditOutlined,
  LocalHospitalOutlined,
  SummarizeOutlined,
  AssignmentIndOutlined,
  MenuBookOutlined,
} from "@mui/icons-material";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import FlexBetween from "./FlexBetween";
import { useDispatch } from "react-redux";
import { setMode } from "../redux/global";
import { Icon } from "@iconify/react";

const Navbar = ({
  showAdminBoard,
  showMIBoard,
  showReviewerBoard,
  showChiefBoard,
  // showModeratorBoard,
  currentUser,
  logOut,
  isNavbarOpen,
  setIsNavbarOpen,
  isNonMobile,
  drawerWidth,
}) => {
  const { pathname } = useLocation();
  const [active, setActive] = useState("");
  const navigate = useNavigate();
  const theme = useTheme();
  const dispatch = useDispatch();
  const isDark = theme.palette.mode === "dark";

  useEffect(() => {
    setActive(pathname.substring(1));
  }, [pathname]);

  const navItems = [
    {
      text: "Home",
      route: "",
      icon: <HomeOutlined />,
      necessary: true,
      external: false,
    },
    {
      text: "About",
      route: "about",
      icon: <InfoOutlined />,
      necessary: true,
      external: false,
    },
    {
      text: "Residents",
      route: "residents",
      icon: <LocalHospitalOutlined />,
      necessary: true,
      external: false,
    },
    {
      text: "Residents Total",
      route: "residents_total",
      icon: <SummarizeOutlined />,
      necessary: true,
      external: false,
    },
    {
      text: "Manage Residents",
      route: "manage_residents",
      icon: <AssignmentIndOutlined />,
      necessary: showChiefBoard,
      external: false,
    },
    {
      text: "Cookbook",
      route: "cookbook",
      icon: <MenuBookOutlined />,
      necessary: Boolean(currentUser),
      external: false,
    },
    {
      text: "MI Form",
      route: "miform",
      icon: <Icon icon="material-symbols-light:heart-broken" width={"22"} />,
      necessary: showMIBoard,
      external: false,
    },
    {
      text: "MI Table",
      route: "mitable",
      icon: <Icon icon="material-symbols-light:heart-broken" width={"22"} />,
      necessary: showMIBoard,
      external: false,
    },
    {
      text: "MI Statistics",
      route: "mistats",
      icon: <Icon icon="material-symbols-light:heart-broken" width={"22"} />,
      necessary: showMIBoard,
      external: false,
    },
    // {
    //   text: "Enter Patient",
    //   route: "enter_patient",
    //   icon: <Icon icon="mdi:patient-outline" width={"24"} />,
    //   necessary: false,
    //   external: false,
    // },
    // {
    //   text: "Measurement Table",
    //   route: "measurement_table",
    //   icon: <TableChart />,
    //   necessary: false,
    //   external: false,
    // },
    // {
    //   text: "Measurement Plot",
    //   route: "measurement_plot",
    //   icon: <InsertChartOutlined />,
    //   necessary: false,
    //   external: false,
    // },
    {
      text: "Systematic Reviews",
      route: "reviews",
      icon: <Icon icon="material-symbols-light:fact-check-outline" width={"22"} />,
      necessary: showReviewerBoard,
      external: false,
    },
    {
      text: "Manage Roles",
      route: "admin",
      icon: <SupervisorAccountOutlined />,
      necessary: showAdminBoard,
      external: false,
    },
    {
      text: "Manage Telecons",
      route: "telecons",
      icon: <Groups />,
      necessary: showAdminBoard,
      external: false,
    },
    {
      text: "Edit Site Content",
      route: "edit_site_content",
      icon: <EditOutlined />,
      necessary: showAdminBoard,
      external: false,
    },
    // {
    //   text: "Moderator Board",
    //   route: "mod",
    //   icon: <ShieldOutlined />,
    //   necessary: showModeratorBoard,
    // },
    // {
    //   text: "User",
    //   route: "user",
    //   icon: <PersonOutlineOutlined />,
    //   necessary: currentUser,
    // },
  ];

  return (
    <Box component="nav">
      {isNavbarOpen && (
        <Drawer
          open={isNavbarOpen}
          onClose={() => setIsNavbarOpen(false)}
          variant="persistent"
          anchor="left"
          sx={{
            width: drawerWidth,
            "& .MuiDrawer-paper": {
              color: theme.palette.text.primary,
              backgroundColor: theme.palette.background.alt,
              backgroundImage: "none",
              boxSizing: "border-box",
              border: "none",
              width: drawerWidth,
              display: "flex",
              flexDirection: "column",
            },
          }}
        >
          <Box
            display="flex"
            flexDirection="column"
            height="100%"
            width="100%"
          >
            <Box p="1.5rem 1.25rem 1rem 1.25rem">
              <FlexBetween>
                <Box display="flex" alignItems="center" gap="0.65rem">
                  <Box
                    component="img"
                    src={"/logo512.png"}
                    alt="Logo"
                    sx={{
                      width: 38,
                      height: 38,
                      borderRadius: "10px",
                      objectFit: "cover",
                    }}
                  />
                  <Typography
                    variant="h5"
                    fontWeight={700}
                    letterSpacing="-0.01em"
                    color={theme.palette.text.primary}
                  >
                    HeisenbergK
                  </Typography>
                </Box>
                <Box display="flex" alignItems="center">
                  <Tooltip
                    title={isDark ? "Switch to light mode" : "Switch to dark mode"}
                  >
                    <IconButton
                      onClick={() => dispatch(setMode())}
                      color="inherit"
                      size="small"
                    >
                      {isDark ? (
                        <Brightness7 fontSize="small" />
                      ) : (
                        <Brightness4 fontSize="small" />
                      )}
                    </IconButton>
                  </Tooltip>
                  {!isNonMobile && (
                    <IconButton
                      onClick={() => setIsNavbarOpen(!isNavbarOpen)}
                      color="inherit"
                      size="small"
                    >
                      <ChevronLeft fontSize="small" />
                    </IconButton>
                  )}
                </Box>
              </FlexBetween>
            </Box>

            <Box flexGrow={1} sx={{ overflowY: "auto", px: "0.75rem" }}>
              <List sx={{ display: "flex", flexDirection: "column", gap: "0.15rem" }}>
                {navItems.map(({ text, route, icon, necessary, external }) => {
                  if (!necessary) return null;
                  const lcText = route;
                  const isActive = active === lcText || (lcText !== "" && active.startsWith(`${lcText}/`));
                  return (
                    <ListItem key={text} disablePadding>
                      <ListItemButton
                        onClick={() => {
                          if (!external) {
                            navigate(`/${lcText}`);
                            setActive(lcText);
                          } else {
                            window.open(lcText, "_blank", "noreferrer");
                          }
                          if (!isNonMobile) {
                            setIsNavbarOpen(false);
                          }
                        }}
                        sx={{
                          borderRadius: "10px",
                          py: "0.6rem",
                          pl: "0.85rem",
                          backgroundColor: isActive
                            ? alpha(theme.palette.secondary.main, isDark ? 0.16 : 0.12)
                            : "transparent",
                          borderLeft: isActive
                            ? `3px solid ${theme.palette.secondary.main}`
                            : "3px solid transparent",
                          color: isActive
                            ? theme.palette.secondary.main
                            : theme.palette.text.secondary,
                          "&:hover": {
                            backgroundColor: isActive
                              ? alpha(theme.palette.secondary.main, isDark ? 0.2 : 0.16)
                              : alpha(theme.palette.text.primary, isDark ? 0.06 : 0.045),
                          },
                        }}
                      >
                        <ListItemIcon
                          sx={{
                            minWidth: "34px",
                            color: isActive
                              ? theme.palette.secondary.main
                              : theme.palette.text.secondary,
                          }}
                        >
                          {icon}
                        </ListItemIcon>
                        <ListItemText
                          primary={
                            <Typography
                              fontSize="0.875rem"
                              fontWeight={isActive ? 600 : 500}
                            >
                              {text}
                            </Typography>
                          }
                        />
                      </ListItemButton>
                    </ListItem>
                  );
                })}
              </List>
            </Box>

            <Box sx={{ width: "100%", px: "0.75rem", pb: "1rem" }}>
              <Divider sx={{ mb: "0.75rem" }} />
              {currentUser ? (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    borderRadius: "12px",
                    p: "0.6rem 0.75rem",
                    backgroundColor: alpha(theme.palette.text.primary, isDark ? 0.05 : 0.035),
                  }}
                >
                  <Box
                    sx={{ display: "flex", alignItems: "center", gap: "0.6rem", cursor: "pointer", minWidth: 0 }}
                    onClick={() => {
                      navigate(`/profile`);
                      setActive("");
                      if (!isNonMobile) {
                        setIsNavbarOpen(false);
                      }
                    }}
                  >
                    <Avatar
                      sx={{
                        width: 32,
                        height: 32,
                        fontSize: "0.85rem",
                        fontWeight: 700,
                        bgcolor: theme.palette.secondary.main,
                        color: theme.palette.primary[600],
                      }}
                    >
                      {currentUser.username?.charAt(0)?.toUpperCase()}
                    </Avatar>
                    <Typography
                      fontWeight={600}
                      fontSize="0.85rem"
                      noWrap
                      sx={{ color: theme.palette.text.primary }}
                    >
                      {currentUser.username}
                    </Typography>
                  </Box>
                  <Tooltip title="Log out">
                    <IconButton
                      size="small"
                      onClick={() => {
                        logOut();
                        if (!isNonMobile) {
                          setIsNavbarOpen(false);
                        }
                      }}
                      sx={{ color: theme.palette.text.secondary }}
                    >
                      <LogoutOutlined fontSize="small" />
                    </IconButton>
                  </Tooltip>
                </Box>
              ) : (
                <FlexBetween gap="0.6rem">
                  <Button
                    fullWidth
                    variant="outlined"
                    startIcon={<LockOutlined fontSize="small" />}
                    onClick={() => {
                      navigate("/login");
                      setActive("login");
                      if (!isNonMobile) {
                        setIsNavbarOpen(false);
                      }
                    }}
                    sx={{
                      color: theme.palette.text.primary,
                      borderColor: theme.palette.divider,
                    }}
                  >
                    Login
                  </Button>
                  <Button
                    fullWidth
                    variant="contained"
                    color="secondary"
                    onClick={() => {
                      navigate("/register");
                      setActive("register");
                      if (!isNonMobile) {
                        setIsNavbarOpen(false);
                      }
                    }}
                  >
                    Register
                  </Button>
                </FlexBetween>
              )}
            </Box>
          </Box>
        </Drawer>
      )}
    </Box>
  );
};

export default Navbar;
